import CheckoutController from '@jwp/ott-common/src/controllers/CheckoutController';
import { getModule } from '@jwp/ott-common/src/modules/container';
import { useState, useEffect } from 'react';

const useCustomOffers = () => {
  const [offers, setOffers] = useState<{ [key: string]: any }[]>([]);
  const [cleengOfferLoading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const checkoutController = getModule(CheckoutController);
  useEffect(() => {
    const getOffers = async () => {
      try {
        const response = await checkoutController.getAllCleengOffers();
        setOffers(response);
      } catch (err) {
        setError(err as any);
      } finally {
        setLoading(false);
      }
    };

    getOffers();
  }, []);
  

  return { offers, cleengOfferLoading, error };
};

export default useCustomOffers;
